var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.666 25.3555C19.1381 25.3555 24.3848 19.8902 24.3848 13.1484C24.3848 6.40669 19.1381 0.941406 12.666 0.941406C6.19394 0.941406 0.947266 6.40669 0.947266 13.1484C0.947266 19.8902 6.19394 25.3555 12.666 25.3555ZM8.5405 10.9316H10.9738V8.75776C10.9738 6.23687 12.4513 4.86475 14.6101 4.86475C15.3387 4.86205 16.067 4.90083 16.7916 4.98091V7.61567H15.3029C14.1283 7.61567 13.9009 8.19707 13.9009 9.05034V10.9316H16.7092L16.3433 13.8857H13.9011V21.4321H10.9738V13.8857H8.5405V10.9316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooter);
export default __webpack_public_path__ + "static/media/facebook-footer.45963680f3fd5ff1a61c528b8a76a4a6.svg";
export { ForwardRef as ReactComponent };